import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { StyleSheet, css } from 'aphrodite';
import Macrobodega from '../../../assets/images/macrobodega.webp'
import MacrobodegaPNG from '../../../assets/images/macrobodega.png'
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight'
import { Link } from 'react-router-dom'
import Routes from '../../../routes'
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { isIOS, isSafari } from 'mobile-device-detect';

const styles = StyleSheet.create({
    hero: {
        backgroundColor: '#449DD1',
        color: '#fff'
    },
    title: {
        color: '#white',
        fontWeight: 700
    },
    textGray: {
        color: 'white'
    },
    cta: {
        outline: '1px solid #06a77d',
        backgroundColor: '#06a77d',
        color: 'white',
        padding: '10px 30px',
        fontWeight: '700',
        fontSize: '20px',

    },
    image: {
        boxShadow: '-20px -13px #C9DAEA'

    },
    flexy: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'baseline',
    },
    ctaDiv: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '10px'
    },
    list: {
        fontSize: '14px',
        paddingLeft: '50px'
    },
    listItem: {
        marginBottom: '5px',
        fontSize: '18px'
    }
});


class Hero extends Component {
    render() {
        return (
            <div className={css(styles.hero)} >
                <Container fluid={false} >
                    <Row className="py-5">
                        <Col xs={12} md={6} className="py-3">
                            <div>

                                {isIOS && <img type="image/png" className={css(styles.image) + " img-fluid"} src={MacrobodegaPNG} alt="Almacenamiento Seguro" />}
                                {isSafari && <img type="image/png" className={css(styles.image) + " img-fluid"} src={MacrobodegaPNG} alt="Almacenamiento Seguro" />}
                                {!isIOS && <img type="image/webp" className={css(styles.image) + " img-fluid"} src={Macrobodega} alt="Almacenamiento Seguro" />}
                            </div>
                        </Col>
                        <Col xs={12} md={6} className={css(styles.flexy) + " py-3"} >
                            <h2 className={css(styles.title) + " py-3"}>Obtén el mejor precio posible y todos los beneficios de una Macrobodega.</h2>
                            <p className={css(styles.textGray) + " lead py-3"}>
                                Somos tu bodega inteligente y los únicos que ofrecen:
                            </p>
                            <div className={css(styles.list) + " py-3"}>
                                <p className={css(styles.listItem)}><FaArrowRight /> Servicio a Domicilio.</p>
                                <p className={css(styles.listItem)}><FaArrowRight /> Emplayamos y protegemos todas tus cosas.</p>
                                <p className={css(styles.listItem)}><FaArrowRight /> Paga solo por el espacio que ocupas.</p>
                                <p className={css(styles.listItem)}><FaArrowRight /> Macrobodegas certificadas y con póliza de seguro.</p>
                                <p className={css(styles.listItem)}><FaArrowRight /> Inventario electrónico con fotografías.</p>
                                <p className={css(styles.listItem)}><FaArrowRight /> Precios en línea.</p>
                            </div>
                            <div className={css(styles.ctaDiv)}>
                                <a href={Routes.NewRequest.url + "?from=cotiza-hoy"} className={css(styles.cta) + ""}>Cotiza Hoy</a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Hero;